import { WarehouseError } from 'common/api-types/warehouse';
import {
  ExpectedApiErrorNotification,
  ExpectedApiErrorNotificationProps,
  ExpectedPageApiError,
} from 'common/components/cookbook/ExpectedApiErrorNotification/ExpectedApiErrorNotification';

const toWarehouseApiErrorLocaleKey = (code: string) => `warehouse.error_code:${code}`;

type Props = Omit<
  ExpectedApiErrorNotificationProps<WarehouseError['code']>,
  'toLocaleKey' | 'formatter'
>;

export const WarehouseApiErrorNotification = ({ error, size, className }: Props) => (
  <ExpectedApiErrorNotification<WarehouseError['code']>
    error={error}
    size={size}
    className={className}
    toLocaleKey={toWarehouseApiErrorLocaleKey}
  />
);

export const WarehousePageApiError = ({ error }: Pick<Props, 'error'>) => (
  <ExpectedPageApiError<WarehouseError['code']>
    error={error}
    toLocaleKey={toWarehouseApiErrorLocaleKey}
  />
);
